/* Comportamenti della landing Stained Glass Blueprint, versione 2 (22/09/2026).
   Rispetto alla versione 1: niente conto alla rovescia (la data di fine lancio e'
   stata tolta, decisione di Giuseppe), il bottone portava al carrello (dal 23/09 va alla cassa), le collezioni
   si leggono dalla pagina. I contatori restano come erano: decisione di Giuseppe. */
(function(){

// ─────────── IL NEGOZIO ───────────
// Siamo dentro Shopify: il carrello si chiama con un percorso relativo, cosi'
// Shopify vede l'aggiunta al carrello e la conta nelle sue statistiche.
const VARIANTE = 58756898062600;
// true = dal bottone si passa dal carrello. false = dritti alla cassa.
// Dal 23/09 dritti alla cassa (decisione di Giuseppe): la pagina carrello di Horizon
// e' generica e il 22-23/09 ha perso 3 carrelli su 5.
const VAI_AL_CARRELLO = false;

// ─────────── PIXEL META ───────────
// Qui NON si tocca il pixel: su Shopify lo inietta il canale Facebook, e spara da
// solo PageView, AddToCart, InitiateCheckout e Purchase. Rimetterlo conterebbe doppio.

async function vaiAlCheckout(bottone){
  if(bottone.dataset.caricando === "1") return;
  try { window.gtag && window.gtag("event","begin_checkout",{currency:"USD",value:27,
    items:[{item_id:"SGB-240",item_name:"Stained Glass Blueprint, 240 patterns",price:27,quantity:1}]}); } catch(e) {}

  bottone.dataset.caricando = "1";
  const testo = bottone.textContent;
  bottone.style.opacity = "0.6";
  bottone.style.pointerEvents = "none";
  bottone.textContent = "Loading...";
  const dove = VAI_AL_CARRELLO ? "/cart" : "/checkout";
  try {
    // update.js e non add.js: il carrello di Shopify resta tra una visita e l'altra, e
    // con add.js chi ripremeva il bottone si trovava 2 copie a $74 (trovato il 23/09).
    // Cosi' la quantita' e' sempre 1, qualunque cosa ci fosse prima.
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({ updates: { [VARIANTE]: 1 } })
    });
    if(!res.ok) throw new Error("cart/update " + res.status);
    window.location.href = dove;
  } catch(e) {
    // Rete di sicurezza: il permalink crea un carrello con una copia sola e va alla cassa.
    console.error("Checkout error", e);
    window.location.href = "/cart/" + VARIANTE + ":1";
  } finally {
    // Se la pagina torna indietro dalla cache, il bottone non deve restare spento.
    setTimeout(() => {
      bottone.dataset.caricando = "0"; bottone.style.opacity = "";
      bottone.style.pointerEvents = ""; bottone.textContent = testo;
    }, 4000);
  }
}

// Il bottone in apertura porta all'offerta (prima si vede cosa si compra); tutti gli
// altri bottoni verso #offerta mettono nel carrello.
document.addEventListener("click", ev => {
  const a = ev.target.closest("a.bottone[href='#offerta']");
  if(!a) return;
  ev.preventDefault();
  if(a.dataset.scorri === "1"){
    document.getElementById("offerta")?.scrollIntoView({ behavior: "auto", block: "start" });
    return;
  }
  vaiAlCheckout(a);
});

// I link interni che non sono bottoni: salto secco, affidabile anche con gli elementi
// che entrano mentre si scorre.
document.addEventListener("click", ev => {
  const a = ev.target.closest('a[href^="#"]');
  if(!a || a.classList.contains("bottone")) return;
  const id = a.getAttribute("href").slice(1);
  const meta = id && document.getElementById(id);
  if(!meta) return;
  ev.preventDefault();
  meta.scrollIntoView({behavior: "auto", block: "start"});
  history.replaceState(null, "", "#" + id);
});
if(location.hash.length > 1){
  const meta = document.getElementById(location.hash.slice(1));
  if(meta) setTimeout(() => meta.scrollIntoView({behavior:"auto", block:"start"}), 350);
}

// ─────────── I CONTATORI (come nella versione 1) ───────────
const NUMERI = {
  guardanoOra: 47,
  ordiniSettimana: 127,
  postiRimasti: 23,
  postiTotali: 100,
  ultimiOrdini: [
    {nome: "Diane", luogo: "Ohio", minutiFa: 12},
    {nome: "Marcus", luogo: "Georgia", minutiFa: 38},
    {nome: "Priya", luogo: "Toronto, ON", minutiFa: 54},
    {nome: "Sara", luogo: "Oregon", minutiFa: 73}
  ]
};

const pastiglia = document.getElementById("guardano");
if(pastiglia){
  const base = NUMERI.guardanoOra;
  const minimo = Math.max(3, Math.round(base * 0.7)), massimo = Math.round(base * 1.3);
  const stretta = n => Math.max(minimo, Math.min(massimo, n));
  let ora = stretta(base + Math.round((Math.random() * 2 - 1) * base * 0.25));
  const scrivi = () => { pastiglia.innerHTML = '<i class="pallino"></i><span><b>' + ora +
    " people</b> are viewing this page right now</span>"; };
  scrivi(); pastiglia.classList.add("acceso");
  const cambia = () => {
    ora = stretta(ora + (Math.random() < .5 ? -1 : 1) * (1 + Math.floor(Math.random() * 3)));
    scrivi(); setTimeout(cambia, 7000 + Math.random() * 8000);
  };
  setTimeout(cambia, 7000 + Math.random() * 8000);
}
["settimana","settimana-2"].forEach(id => {
  const el = document.getElementById(id);
  if(el){ el.innerHTML = "🔥 " + NUMERI.ordiniSettimana + " people enrolled this week"; el.classList.add("acceso"); }
});
const posti = document.getElementById("posti");
if(posti){
  const venduti = Math.max(0, Math.min(100, 100 - (NUMERI.postiRimasti / NUMERI.postiTotali) * 100));
  posti.innerHTML = "⚠️ Only " + NUMERI.postiRimasti + " spots left at this price" +
    '<span class="barra"><i style="width:' + venduti.toFixed(0) + '%"></i></span>';
  posti.classList.add("acceso");
}
const postiBarra = document.getElementById("posti-barra");
if(postiBarra){
  postiBarra.textContent = "⚠️ Only " + NUMERI.postiRimasti + " spots left at this price";
  postiBarra.classList.add("acceso");
}
const avviso = document.getElementById("avviso");
if(avviso && NUMERI.ultimiOrdini.length){
  let i = 0;
  const mostra = () => {
    const o = NUMERI.ultimiOrdini[i % NUMERI.ultimiOrdini.length]; i++;
    avviso.querySelector(".testo").innerHTML = "<b>" + o.nome + " in " + o.luogo +
      "</b> just got the 240 patterns" + '<div class="quando">' + o.minutiFa + " minutes ago</div>";
    avviso.classList.add("dentro");
    setTimeout(() => avviso.classList.remove("dentro"), 6500);
    setTimeout(mostra, 25000 + Math.random() * 15000);
  };
  setTimeout(mostra, 6000);
  avviso.querySelector(".chiudi").addEventListener("click", () => avviso.remove());
}

// ─────────── LE SEI COLLEZIONI ───────────
// I dati stanno dentro la pagina, scritti dal generatore con gli indirizzi gia'
// risolti: nessuna chiamata di rete, la galleria non puo' restare vuota.
(() => {
  const sorgente = document.getElementById("dati-collezioni");
  if(!sorgente) return;
  let d = null;
  try { d = JSON.parse(sorgente.textContent); } catch(e) { return; }
  const chiavi = Object.keys(d).sort();
  const linguette = document.getElementById("linguette");
  const tendina = document.getElementById("tendina");
  const vetrina = document.getElementById("vetrina");
  const didascalia = document.getElementById("didascalia");
  if(!linguette || !vetrina) return;
  const disegna = chiave => {
    const c = d[chiave];
    vetrina.innerHTML = c.schemi.map((s, i) =>
      '<figure style="animation-delay:' + (i * 45) + 'ms" role="button" tabindex="0" data-i="' + i +
      '" aria-label="Open the ' + s.titolo + ' pattern full size">' +
      '<img src="' + s.url + '" alt="' + s.titolo + ' pattern" loading="lazy">' +
      '<span class="lente" aria-hidden="true">⤢</span>' +
      '<figcaption>' + s.titolo + '<br>' + s.celle + ' cells</figcaption></figure>').join("");
    vetrina.dataset.chiave = chiave;
    didascalia.textContent = c.totale + " patterns in " + c.nome.toLowerCase() +
      ", from a first piece to a whole evening. These nine are a sample.";
    [...linguette.children].forEach(b =>
      b.setAttribute("aria-selected", b.dataset.chiave === chiave ? "true" : "false"));
    tendina.value = chiave;
  };
  chiavi.forEach(k => {
    const b = document.createElement("button");
    b.className = "linguetta"; b.type = "button"; b.setAttribute("role","tab");
    b.dataset.chiave = k;
    b.innerHTML = d[k].nome + "<span>" + d[k].totale + "</span>";
    b.addEventListener("click", () => disegna(k));
    linguette.appendChild(b);
    const o = document.createElement("option");
    o.value = k; o.textContent = d[k].nome + " (" + d[k].totale + ")";
    tendina.appendChild(o);
  });
  tendina.addEventListener("change", e => disegna(e.target.value));
  disegna(chiavi[0]);

  // ─────────── LO SCHEMA A TUTTO SCHERMO (25/09) ───────────
  // Clarity: chi arriva tocca gli schemi della galleria per vederli meglio e non
  // succedeva niente. Ora un tocco apre lo schema grande; di lato il foglio numerato.
  const PREZZO = "$27";
  const box = document.createElement("div");
  box.className = "lightbox"; box.hidden = true;
  box.setAttribute("role", "dialog"); box.setAttribute("aria-modal", "true");
  box.innerHTML =
    '<div class="lb-pannello">' +
      '<div class="lb-testa"><div><b class="lb-nome"></b><span class="lb-info"></span></div>' +
      '<button type="button" class="lb-chiudi" aria-label="Close">×</button></div>' +
      '<div class="lb-schede"><button type="button" data-v="0" aria-selected="true">The pattern</button>' +
      '<button type="button" data-v="1" aria-selected="false">Numbered sheet</button></div>' +
      '<div class="lb-scorri"><figure><img alt=""></figure><figure><img alt=""></figure></div>' +
      '<p class="lb-nota">The numbers mark each cell so you can plan your own colors in pencil first.</p>' +
      '<a class="bottone largo lb-compra" href="#offerta">Get all 240 patterns for ' + PREZZO + '</a>' +
    '</div>';
  document.body.appendChild(box);
  const scorri = box.querySelector(".lb-scorri");
  const schede = [...box.querySelectorAll(".lb-schede button")];
  const nota = box.querySelector(".lb-nota");
  const segna = v => {
    schede.forEach(b => b.setAttribute("aria-selected", b.dataset.v == v ? "true" : "false"));
    nota.style.visibility = v == 1 ? "visible" : "hidden";
  };
  schede.forEach(b => b.addEventListener("click", () =>
    scorri.scrollTo({ left: scorri.clientWidth * b.dataset.v, behavior: "smooth" })));
  scorri.addEventListener("scroll", () => segna(Math.round(scorri.scrollLeft / scorri.clientWidth)));
  const chiudi = () => { box.hidden = true; document.documentElement.classList.remove("lb-aperto"); };
  const apri = s => {
    box.querySelector(".lb-nome").textContent = s.titolo;
    box.querySelector(".lb-info").textContent = s.celle + " cells · " + s.livello;
    const img = box.querySelectorAll(".lb-scorri img");
    img[0].src = s.grande || s.url; img[0].alt = s.titolo + " pattern, full size";
    img[1].src = s.num || s.url;    img[1].alt = s.titolo + " numbered sheet";
    box.hidden = false; document.documentElement.classList.add("lb-aperto");
    scorri.scrollLeft = 0; segna(0);
    box.querySelector(".lb-chiudi").focus();
  };
  const daFigura = f => d[vetrina.dataset.chiave].schemi[+f.dataset.i];
  vetrina.addEventListener("click", e => { const f = e.target.closest("figure[data-i]"); if(f) apri(daFigura(f)); });
  vetrina.addEventListener("keydown", e => {
    const f = e.target.closest("figure[data-i]");
    if(f && (e.key === "Enter" || e.key === " ")){ e.preventDefault(); apri(daFigura(f)); }
  });
  box.querySelector(".lb-chiudi").addEventListener("click", chiudi);
  box.addEventListener("click", e => { if(e.target === box) chiudi(); });
  document.addEventListener("keydown", e => { if(e.key === "Escape" && !box.hidden) chiudi(); });
  // Il bottone dentro la finestra passa dal gestore normale (update.js e cassa);
  // qui chiudo soltanto, cosi' se la pagina torna indietro non la ritrova aperta.
  box.querySelector(".lb-compra").addEventListener("click", () => setTimeout(chiudi, 300));
})();

})();
